import * as z from 'zod';

import { LosId } from '../../BrandedIds';
import { DateString, NonNegativeMonetaryValue } from '../fields';

export const RecordEscrowDisbursementRow = z.object({
  loanId: LosId,
  disbursementType: z.enum(['escrow']),
  disbursementDate: DateString,
  disbursementTotal: NonNegativeMonetaryValue,
  disbursementRecipient: z.string(),
  policyNumber: z.string().optional(),
  updateNextPaymentAmount: z.boolean().optional(),
  note: z.string().optional(),
});
export type RecordEscrowDisbursementRow = z.infer<typeof RecordEscrowDisbursementRow>;

export const RECORD_ESCROW_DISBURSEMENT_ROW_REQUIRED_FIELDS = Object.keys(RecordEscrowDisbursementRow.shape).filter(
  (key) => !RecordEscrowDisbursementRow.shape[key as keyof typeof RecordEscrowDisbursementRow.shape].isOptional(),
);
